module.exports = __webpack_public_path__ + "img/Slideshows-espace-client-guide-rs.1b477673.png";